{% block sw_cms_element_dvsn_form_builder %}
    <div class="sw-cms-el-dvsn-form-builder">
        <h4>Lorem ipsum dolor sit amet</h4>
        <hr class="sw-cms-el-dvsn-form-builder-hr">

        <div class="sw-cms-el-dvsn-form-builder-grid-container-1-1">
            <div class="sw-cms-el-dvsn-form-builder-placeholder"></div>
            <div></div>
        </div>

        <div class="sw-cms-el-dvsn-form-builder-grid-container-1-1">
            <div class="sw-cms-el-dvsn-form-builder-placeholder"></div>
            <div class="sw-cms-el-dvsn-form-builder-placeholder"></div>
        </div>

        <div class="sw-cms-el-dvsn-form-builder-grid-container-1-1">
            <div class="sw-cms-el-dvsn-form-builder-placeholder"></div>
            <div class="sw-cms-el-dvsn-form-builder-placeholder"></div>
        </div>

        <div class="sw-cms-el-dvsn-form-builder-placeholder"></div>
        <div class="sw-cms-el-dvsn-form-builder-placeholder"></div>
        <div class="sw-cms-el-dvsn-form-builder-placeholder"></div>
        <div class="sw-cms-el-dvsn-form-builder-placeholder-big"></div>

        <div class="sw-cms-el-dvsn-form-builder-button">
            <button>Lorem ipsum</button>
        </div>
    </div>
{% endblock %}